export default {
  SET_ACTIVE_TAB: 'SET_ACTIVE_TAB',
  SET_SORTING_FUNCTION: 'SET_SORTING_FUNCTION',
  SET_SELECTED_LANGUAGE: 'SET_SELECTED_LANGUAGE',

  DOWNLOAD_POSTER_REQUEST: 'DOWNLOAD_POSTER_REQUEST',
  DOWNLOAD_POSTER_SUCCESS: 'DOWNLOAD_POSTER_SUCCESS',
  DOWNLOAD_POSTER_FAILURE: 'DOWNLOAD_POSTER_FAILURE',

  FETCH_POSTER_URL_REQUEST: 'FETCH_POSTER_URL_REQUEST',
  FETCH_POSTER_URL_SUCCESS: 'FETCH_POSTER_URL_SUCCESS',
  FETCH_POSTER_URL_FAILURE: 'FETCH_POSTER_URL_FAILURE',

  FETCH_RETAILER_DETAILS_REQUEST: 'FETCH_RETAILER_DETAILS_REQUEST',
  FETCH_RETAILER_DETAILS_SUCCESS: 'FETCH_RETAILER_DETAILS_SUCCESS',
  FETCH_RETAILER_DETAILS_FAILURE: 'FETCH_RETAILER_DETAILS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/utils/actions/action-types.js